import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

// Css
import { Form } from './styles';

// Js
import { useForm } from '../../../Components/General/Form/useForm'
import { GlobalContext } from '../../../Global/GlobalContext';
import { updateMessage, getSingleMessage } from '../../../Global/api';
import ValidationRequired from '../../../Infra/General/Validation/ValidationRequired';

// Components
import Input from '../../../Components/General/Form/Input'
import ButtonOne from '../../../Components/General/Buttons/ButtonOne';
import Textarea from '../../../Components/General/Form/Textarea';
import Select from '../../../Components/General/Form/Select';

const Update = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const { setLoading, showMessage } = React.useContext(GlobalContext);

    const arrPath = location.pathname.split('/');
    const id = arrPath[arrPath.length - 1];

    // Form
    const formRef = React.useRef(null);
    const name = useForm();
    const city = useForm();
    const content = useForm();
    const socialMedia = useForm();
    const listSocialMedia = {
        "0": {
            "value": "instagram",
            "label": "Instagram"
        },
        "1": {
            "value": "facebook",
            "label": "Facebook"
        },
        "2": {
            "value": "twitter",
            "label": "Twitter"
        }
    }


    React.useEffect(() => {
        setLoading(1);

        getSingleMessage(id)
            .then(res => {
                setLoading(0);
                
                name.setValue(res.data().name);
                city.setValue(res.data().city);
                content.setValue(res.data().content);
                socialMedia.setValue(res.data().socialmedia);
            })
            .catch(res => {
                setLoading(0);
                showMessage('O item foi removido com sucesso', 200);
                navigate('/dashboard/mensagens');
            });
    }, [])

    function onSubmit(e){
        e.preventDefault();
        const validation = new ValidationRequired(formRef.current);

        if(validation.isValid()) saveNewItem();
    }

    function saveNewItem(){
        setLoading(1);
        
        updateMessage({
            "name": name.value,
            "city": city.value,
            "content": content.value,
            "socialmedia": socialMedia.value
        }, id)
        .then(res => {
            showMessage('Dados salvos com sucesso', 200);
            setLoading(0);
        })
        .catch(res => {
            setLoading(0);
            showMessage("Ocorreu um erro ao tentar salvar os dados", 400)
        });
    }

    return (
        <Form ref={formRef}>
            <h2>Editar Item</h2>

            <div className="inputs">
                <Input 
                    label="Nome"
                    name="name"
                    type="text"
                    validName="required"
                    className="input-standard"
                    {...name}
                />

                <Input 
                    label="Cidade"
                    name="city"
                    type="text"
                    className="input-standard"
                    {...city}
                />

                <Textarea 
                    label="Conteúdo"
                    name="content"
                    type="text"
                    className="input-standard"
                    {...content}
                />

                <Select 
                    label="Social Media"
                    name="socialMedia"
                    type="text"
                    validName="required"
                    className="input-standard"
                    list={listSocialMedia}
                    {...socialMedia}
                />
            </div>
            
            <ButtonOne
                width={200}
                height={50}
                onClick={onSubmit}
            >
                Enviar
            </ButtonOne>
        </Form>
    )
}

export default Update
